var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Pipe } from '@angular/core';
import { GroupByPipe } from './group-by';
// tslint:disable use-pipe-transform-interface
var GroupByImpurePipe = (function (_super) {
    __extends(GroupByImpurePipe, _super);
    function GroupByImpurePipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupByImpurePipe.decorators = [
        { type: Pipe, args: [{ name: 'groupByImpure', pure: false },] },
    ];
    /** @nocollapse */
    GroupByImpurePipe.ctorParameters = function () { return []; };
    return GroupByImpurePipe;
}(GroupByPipe));
export { GroupByImpurePipe };
//# sourceMappingURL=group-by-impure.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/group-by-impure.js
// module id = 224
// module chunks = 4